import { render, staticRenderFns } from "./GroupSendList.vue?vue&type=template&id=d3bd558a&scoped=true"
import script from "./GroupSendList.vue?vue&type=script&lang=js"
export * from "./GroupSendList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3bd558a",
  null
  
)

export default component.exports